import SharedFileUploaderModal from "Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./useFileUploaderModal";
import { useInvoices } from "../../../../useInvoices";

function FileUploaderModal() {
  const { display, closeModal } = useFileUploaderModal();

  const uploadPath = `${process.env.REACT_APP_API}/api/workflow/uploadinvoice`;

  return (
    <SharedFileUploaderModal
      display={display}
      onClose={closeModal}
      uploadPath={uploadPath}
      multiple={false}
      title="Upload Invoice"
      subtitle="Select an invoice file to upload"
      successMessage="File uploaded successfully"
      onUploaded={(data) => useInvoices.getState().attachFile(data[0].url)}
    />
  );
}

export default FileUploaderModal;
